import type { ReactNode } from 'react'

export interface ContentBriefBlockCommentProps {
  comment: string
}

export const ContentBriefBlockComment: React.FC<ContentBriefBlockCommentProps> = ({
  comment,
}): ReactNode => (
  <div className="content-brief-block-comment border-t border-primary/20 px-3 py-2">
    <p className="text-sm text-muted-foreground">{comment}</p>
  </div>
)
